(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[653],{

/***/ 8065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ customer_engagement_stack; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/DividerSection/index.ts
var DividerSection = __webpack_require__(85507);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/templates/Forms/EmailCaptureForm/index.ts + 3 modules
var EmailCaptureForm = __webpack_require__(41948);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/useScrollToAnchor.tsx
var useScrollToAnchor = __webpack_require__(83390);
// EXTERNAL MODULE: ./src/views/CustomerEngagementStack/components/Hero/assets/Hero.png
var assets_Hero = __webpack_require__(15049);
var Hero_default = /*#__PURE__*/__webpack_require__.n(assets_Hero);
// EXTERNAL MODULE: ./src/views/CustomerEngagementStack/components/Hero/assets/Hero.webp
var Hero_assets_Hero = __webpack_require__(2823);
var assets_Hero_default = /*#__PURE__*/__webpack_require__.n(Hero_assets_Hero);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/CustomerEngagementStack/components/Hero/Hero.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var copy = {
  overline: "A Guide to Customer-Centric Tools & Technologies",
  heading: "The Customer Engagement Stack",
  linkText: "Continue reading",
  formDescription: "Want to save this as a resource? Download the ebook below.",
  description: "Welcome to the second annual edition of 'The Customer Engagement Stack', our yearly exploration of the leading tools and tactics businesses around the world are using to elevate customer interactions."
};
var Hero_button = {
  text: "Download the ebook",
  url: "https://segment.com/pdfs/ebook-the-customer-engagement-stack-2024.pdf"
};

var Hero = function Hero() {
  var scrollToIntro = (0,useScrollToAnchor/* default */.Z)("introduction", -80);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    id: "download-the-ebook",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeroBase, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroCopy, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: copy.overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h1",
            tag: "h1",
            children: copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "pLarge",
            tag: "p",
            children: copy.description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButtonText, {
            iconEnd: Common/* ChevronDownIcon */.v4,
            onClick: function onClick() {
              return scrollToIntro();
            },
            children: copy.linkText
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeroContents, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
              type: "image/webp",
              srcSet: "".concat((assets_Hero_default()))
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Image */.Ee, {
              width: "1586",
              height: "892",
              src: (Hero_default()),
              alt: "Illustration: Customer Engagement Stack",
              loading: "lazy"
            })]
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCopyTextBase, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "pLarge",
            tag: "p",
            children: copy.formDescription
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHeroRecipeForm, {
          id: "cnt-customer-eng-stack-2024-form",
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmailCaptureForm/* default */.Z, {
            additionalTrackEvent: "Content Downloaded",
            resourceType: "report",
            buttonText: Hero_button.text,
            successButtonText: Hero_button.text,
            buttonUrl: Hero_button.url,
            successMessageAppearance: "twilioLight",
            customFormIdentifier: "cnt-customer-eng-stack-2024",
            enableJobTitleField: true
          })
        })]
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "e1je0pnp7"
} : 0)("background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var StyledHeroBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* default */.ZP,  true ? {
  target: "e1je0pnp6"
} : 0)(recipes_Hero/* Wrapper */.im, "{justify-content:unset;}" + ( true ? "" : 0));

var contentAlignmentStyles = function contentAlignmentStyles(theme) {
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)(theme.breakpoints.down("md"), "{margin-left:auto;margin-right:auto;}" + ( true ? "" : 0),  true ? "" : 0);
};

var StyledCopyTextBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* default */.ZP,  true ? {
  target: "e1je0pnp5"
} : 0)(function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.between("sm", "md");
}, "{text-align:center;}", function (_ref3) {
  var theme = _ref3.theme;
  return contentAlignmentStyles(theme);
}, ";" + ( true ? "" : 0));

var ImageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1je0pnp4"
} : 0)("max-width:520px;padding-bottom:40px;", function (_ref4) {
  var theme = _ref4.theme;
  return contentAlignmentStyles(theme);
}, ";" + ( true ? "" : 0));

var StyledButtonText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ButtonText/* default */.Z,  true ? {
  target: "e1je0pnp3"
} : 0)( true ? {
  name: "ecp7cz",
  styles: "padding-top:18px"
} : 0);

var heroColumnStyles = function heroColumnStyles(theme) {
  return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("margin:0 auto;", theme.breakpoints.up("lg"), "{max-width:unset;}" + ( true ? "" : 0),  true ? "" : 0);
};

var HeroCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* Copy */.CK,  true ? {
  target: "e1je0pnp2"
} : 0)(function (_ref5) {
  var theme = _ref5.theme;
  return heroColumnStyles(theme);
}, ";align-self:flex-start;text-align:left;" + ( true ? "" : 0));

var HeroContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* Contents */.AU,  true ? {
  target: "e1je0pnp1"
} : 0)(function (_ref6) {
  var theme = _ref6.theme;
  return heroColumnStyles(theme);
}, ";justify-items:unset;" + ( true ? "" : 0));

var StyledHeroRecipeForm = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(recipes_Hero/* Form */.l0,  true ? {
  target: "e1je0pnp0"
} : 0)("max-width:515px;", function (_ref7) {
  var theme = _ref7.theme;
  return contentAlignmentStyles(theme);
}, ";" + ( true ? "" : 0));

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Accordion/index.ts + 26 modules
var Accordion = __webpack_require__(83914);
// EXTERNAL MODULE: ./src/views/CustomerEngagementStack/components/TopDestinationCategories/assets/TopDestinationCategories.png
var assets_TopDestinationCategories = __webpack_require__(37640);
var TopDestinationCategories_default = /*#__PURE__*/__webpack_require__.n(assets_TopDestinationCategories);
;// CONCATENATED MODULE: ./src/views/CustomerEngagementStack/components/TopDestinationCategories/TopDestinationCategories.tsx


function TopDestinationCategories_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var TopDestinationCategories_copy = {
  heading: "Top destination categories through the years",
  description: "Before we get into the leading tools across the customer engagement stack, let\u2019s first plot the trajectory of the different categories of tools on the Twilio Segment platform over the past five years.",
  description2: "This graph not only illustrates a growth pattern \u2013 it narrates the evolving priorities of businesses in an increasingly data-centric world.",
  description3: "Data warehouses, represented by the bold red line, have undergone an extraordinary surge, particularly notable from 2020 onwards. This trend can be attributed to several factors:",
  list: ["Increasing challenges faced by data architects and platform leads, such as fragmented customer data and the need for efficient real-time data processing", "The market demand for platforms that offer integration flexibility with existing systems and scalability to meet evolving business needs", "Businesses outgrowing the limitations of traditional CRMs in favor of versatile, computation-ready data warehouses, spurred by the need for a single source of truth "]
};

var TopDestinationCategories = function TopDestinationCategories() {
  var _useState = (0,react.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopDestinationCategories_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSection, {
      variant: "centered",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* Header */.h4, {
            onClick: function onClick() {
              return setOpen(!open);
            },
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* TitleWrapper */.$t, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Title */.Dx, {
                opened: open,
                variant: "h2",
                children: TopDestinationCategories_copy.heading
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Icon */.JO, {
              opened: open
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Body */.uT, {
            children: open && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* ContentWrapper */.vs, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Text */.xv, {
                tag: "div",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                  variant: "pLarge",
                  children: TopDestinationCategories_copy.description
                })
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, {
                width: "1302",
                height: "1011",
                src: (TopDestinationCategories_default()),
                alt: ""
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* Text */.xv, {
                tag: "div",
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                  variant: "pLarge",
                  children: TopDestinationCategories_copy.description2
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                  variant: "pLarge",
                  children: TopDestinationCategories_copy.description3
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List, {
                  children: TopDestinationCategories_copy.list.map(function (item) {
                    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                      children: item
                    }, item);
                  })
                })]
              })]
            })
          })]
        })
      })
    })
  });
};

var TopDestinationCategories_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eairnp33"
} : 0)( true ? {
  name: "1c6bhpi",
  styles: "max-width:1004px;margin:0 auto"
} : 0);

var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "eairnp32"
} : 0)("overflow:hidden;", Section/* Wrapper */.im, "{padding-bottom:20px;gap:40px;}" + ( true ? "" : 0));

var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "eairnp31"
} : 0)( true ? {
  name: "xdx4gc",
  styles: "margin:40px 0"
} : 0);

var List = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "eairnp30"
} : 0)( true ? {
  name: "tw4sx",
  styles: "display:flex;flex-direction:column;gap:12px"
} : 0);

/* harmony default export */ var TopDestinationCategories_TopDestinationCategories = (TopDestinationCategories);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
// EXTERNAL MODULE: ../../libs/matcha/components/Badge/index.ts + 2 modules
var Badge = __webpack_require__(16154);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/index.ts + 31 modules
var Card = __webpack_require__(74881);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(24330);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
// EXTERNAL MODULE: ../../libs/matcha/components/Paper/index.ts + 2 modules
var Paper = __webpack_require__(16164);
// EXTERNAL MODULE: ../../libs/utils/useActiveState/index.ts + 1 modules
var useActiveState = __webpack_require__(74864);
;// CONCATENATED MODULE: ./src/views/CustomerEngagementStack/components/Categories/Accordions.tsx


function Accordions_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var Accordions = function Accordions(_ref) {
  var data = _ref.data;
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var items = new Array(data.length).fill(false);

  var _useActiveState = (0,useActiveState/* useActiveState */.z)(items, {
    allowMultipleActive: true
  }),
      activeItems = _useActiveState.activeItems,
      toggle = _useActiveState.toggle;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledPaper, {
    background: theme.palette.neutrals.white[100],
    border: "1px solid ".concat(theme.palette.twilio.gray[20]),
    children: activeItems.map(function (active, index) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* default */.ZP, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* Header */.h4, {
          onClick: function onClick() {
            return toggle(index);
          },
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* TitleWrapper */.$t, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Title */.Dx, {
              opened: active,
              children: data[index].title
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Icon */.JO, {
            opened: active
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Body */.uT, {
          children: active && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledAccordionContent, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Text */.xv, {
              tag: "div",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                dangerouslySetInnerHTML: {
                  __html: sanitize_html_default()(data[index].description, {
                    allowedTags: ["a", "ul", "li"]
                  })
                }
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
                href: data[index].type === "docs" ? (0,getAbsoluteUrl/* default */.Z)("".concat(data[index].link), pageConfig) : (0,getAbsoluteUrl/* default */.Z)("/catalog/integrations/".concat(data[index].type).concat(data[index].link, "/"), pageConfig),
                iconEnd: Common/* ChevronRightIcon */.XC,
                children: "See how it works"
              })
            })]
          })
        })]
      }, "item-".concat(index));
    })
  });
};

var StyledPaper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Paper/* default */.Z,  true ? {
  target: "e9notrt2"
} : 0)( true ? {
  name: "1qte7f7",
  styles: "margin-top:40px;padding:20px 40px 40px"
} : 0);

var StyledAccordionContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Accordion/* ContentWrapper */.vs,  true ? {
  target: "e9notrt1"
} : 0)( true ? {
  name: "ka4jpx",
  styles: "overflow:visible;ul{margin-top:20px;}"
} : 0);

var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e9notrt0"
} : 0)( true ? {
  name: "1d0nbku",
  styles: "margin-top:24px"
} : 0);

/* harmony default export */ var Categories_Accordions = (Accordions);
// EXTERNAL MODULE: ./src/views/CustomerEngagementStack/components/Categories/assets/EmailRecipe.png
var EmailRecipe = __webpack_require__(96032);
var EmailRecipe_default = /*#__PURE__*/__webpack_require__.n(EmailRecipe);
// EXTERNAL MODULE: ./src/views/CustomerEngagementStack/components/Categories/assets/AdvertisingRecipe.png
var AdvertisingRecipe = __webpack_require__(63302);
var AdvertisingRecipe_default = /*#__PURE__*/__webpack_require__.n(AdvertisingRecipe);
;// CONCATENATED MODULE: ./src/views/CustomerEngagementStack/components/Categories/data.ts


var data = [{
  slug: "a-b-testing",
  title: "A/B Testing",
  description: "A/B testing is a critical component of an effective customer engagement strategy. By testing different variations of web pages, emails, or ads, businesses can determine which elements are most effective in driving customer behavior. Below we\u2019ll explore some of the top A/B testing tools on the Twilio Segment platform to understand the unique features that can help businesses take their customer engagement to the next level.",
  card: {
    badge: "Recipe",
    title: "A/B test your tech stack",
    description: "In this recipe, you'll learn how to design, run, and analyze an A/B test to determine what marketing tools are generating the most ROI.",
    link: "/AB-test-your-tech-stack"
  },
  list: [{
    title: "Optimizely",
    description: "Leading digital experience platform, Optimizely, was the top A/B testing tool on the Twilio Segment platform for 2022. The platform allows teams to create and optimize digital experiences through data-driven experimentation. It offers a user-friendly interface for A/B and multivariate testing across web and mobile, and shows experiment performance and statistical significance to make decision-making easy. Optimizely also has powerful personalization capabilities, allowing teams to create hyper-targeted experiences for different segments of their audience.",
    type: "destination",
    link: "/optimizely"
  }, {
    title: "Apptimize",
    description: "Apptimize is an A/B testing and release management platform that helps mobile teams drive engagement and revenue through experimentation. It allows users to experiment with different app experiences, messaging, and features without the need for code releases, and it supports a variety of test types including A/B testing, multivariate testing, and feature rollouts. Apptimize also has a powerful visual editor that allows users to design and modify app experiences without any coding skills.",
    type: "destination",
    link: "/apptimize"
  }, {
    title: "AB Tasty",
    description: "AB Tasty is an intuitive experimentation and personalization solution. It allows you to modify sites using a visual editor, without writing any code, and without technical knowledge. You can then measure which versions of your pages produce the best results for your objectives (pageviews, registrations, purchases, etc.). To run a test simply install our tag on the different pages of your site. Once the tag has been added, you don\u2019t have to worry about it anymore, because the same tag allows you to run all your future tests.",
    type: "destination",
    link: "/ab-tasty-client-side/"
  }, {
    title: "Visual Website Optimizer",
    description: "Visual Web Optimizer (VWO) is an all-in-one optimization platform that allows teams to optimize their web experiences through experimentation and personalization. It offers a user-friendly interface for A/B testing and multivariate testing, as well as powerful personalization capabilities. VWO also has a range of other optimization features, such as heatmaps, session recordings, and surveys, to help teams better understand their users and optimize their experiences accordingly.",
    type: "destination",
    link: "/visual-website-optimizer"
  }]
}, {
  slug: "advertising",
  title: "Advertising",
  description: "With so many different advertising platforms available, it can be challenging to choose the right ones for your business. In this section, we'll introduce you to some of the most popular advertising tools used by Twilio Segment customers today. These tools allow you to target specific audiences and deliver personalized messaging, making it easier to engage and convert potential customers.",
  card: {
    badge: "Recipe",
    title: "How to Use Lookalike Audiences and Audience Suppression",
    description: "In this recipe, you\u2019ll learn how to use Twilio Engage (formerly Segment Personas) to create hyper-specific audiences in advertising platforms like Facebook, Snapchat, and Pinterest to increase advertising efficiency.",
    image: (AdvertisingRecipe_default()),
    link: "/increase-advertising-efficiency-lookalike-audiences-advertising-suppression"
  },
  list: [{
    title: "Meta Pixel",
    description: "The Meta Pixel is a piece of code on your website that can help you better understand the effectiveness of your advertising and the actions people take on your site. You\u2019ll also be able to see when customers took an action after seeing your ad on Facebook and Instagram, which can help you with retargeting. As the leading advertising tool on the Twilio Segment platform, some of its top features include conversion, tracking, and remarketing, so marketers can manage ads from one platform.",
    type: "destination",
    link: "/facebook-pixel"
  }, {
    title: "Google Ads",
    description: "<a href=\"https://www.enterpriseappstoday.com/stats/google-ads-statistics.html#:~:text=Key%20Google%20Ads%20Statistics%20(Editor's%20Choice),-Google%20Ads%20is&text=More%20than%2080%25%20of%20businesses,the%20first%20spot%20is%207.94%25.\">More than 80% of businesses</a> worldwide use Google Ads for advertising and pay-per-click (PPC) campaigns on Google's search engine results pages, YouTube, and other websites within the Google Display Network. Be seen where your customers are searching, browsing and watching across the web with these features:\n        <ul>\n        <li>Search trend research and creation of targeted cross-platform Google ads with keyword planner</li>\n        <li>Custom Google ads based on country, city, region, or distance from location</li>\n        <li>\u201CCustomer Match\u201D to market campaigns to target audiences using customer data like email addresses</li>\n        </ul>\n        ",
    type: "destination",
    link: "/actions-google-enhanced-conversions"
  }, {
    title: "LinkedIn",
    description: "Business and social networking platform, LinkedIn, turns 20 years old in 2023. With <a href=\"https://blog.hootsuite.com/linkedin-statistics-business/\">875 million members</a>, the platform offers businesses a variety of advertising options, including sponsored content, sponsored InMail, and display ads. Unique features of LinkedIn ads include the ability to target specific job titles, industries, and company sizes, as well as retarget users who have engaged with a business's content or website.",
    type: "destination",
    link: "/linkedin-audiences"
  }, {
    title: "Bing Ads",
    description: "With over 100 million daily active users and as the <a href=\"https://www.theverge.com/2023/5/23/23733189/chatgpt-bing-microsoft-default-search-openai-build\">default search option for Chat-GPT</a>, Microsoft\u2019s Bing had a big 2023. Bing Ads is Microsoft's advertising platform that allows businesses to place ads on Bing search results pages, as well as other Microsoft-owned properties like MSN and Outlook.com. The ability to import campaigns from Google Ads, target specific demographics or locations, and track conversions using a Universal Event Tracking (UET) tag are just a few of the features Bing Ads has to offer.",
    type: "destination",
    link: "/bing-ads"
  }]
}, {
  slug: "analytics",
  title: "Analytics",
  description: "By analyzing customer data, businesses can gain valuable insights into their customers' behavior, preferences, and needs, which allows them to create more personalized, targeted experiences. In this section, we'll explore some of the top analytics tools being used on the Twilio Segment platform and highlight their unique features and use cases.",
  card: {
    badge: "Recipe",
    title: "Identify high-value users with historical count analysis",
    description: "In this recipe, examine the exact moment in the customer journey that converts new users into high-value customers. Then, create monitoring that surfaces high-value users to build look-a-like audiences.",
    link: "/amplitude-historical-count-analysis"
  },
  list: [{
    title: "Mixpanel",
    description: "Mixpanel is a comprehensive product analytics platform that provides real-time data and insights to help businesses understand how users engage with their products. Its powerful tools enable companies to track user behavior across devices and channels, analyze user interactions, and segment customers based on their actions, enabling them to optimize their product and marketing strategies.",
    type: "destination",
    link: "/mixpanel"
  }, {
    title: "Google Analytics 4",
    description: "Google Analytics 4 (GA4) is Google\u2019s new analytics property, for both websites and applications. GA4 has machine learning at its core to help give you a more complete understanding of your customers across devices and platforms. Emerging in response to changing online privacy norms and consumer patterns, GA4 offers in-depth insights into user interactions, tracking engagement, revenue generation, and retention.",
    type: "docs",
    link: "https://segment.com/docs/connections/destinations/catalog/actions-google-analytics-4/#verifying-event-meet-ga4s-measurement-protocol-api/"
  }, {
    title: "Amplitude",
    description: "Amplitude is a comprehensive product intelligence platform that seamlessly collects and interprets user behavior across digital platforms like websites and mobile apps. Its robust capabilities allow businesses to analyze user engagement, discover patterns, and categorize users based on their behavior. This empowers businesses to make data-driven decisions and execute optimization strategies that enhance user experience and drive business growth.",
    type: "destination",
    link: "/actions-amplitude"
  }, {
    title: "Heap",
    description: "Heap is an easy-to-use product analytics platform that automatically captures and tracks user behavior across websites and mobile apps. Its powerful tools enable businesses to analyze user interactions, identify trends, and segment customers based on their actions, enabling them to optimize their product and marketing strategies.",
    type: "destination",
    link: "/heap"
  }, {
    title: "FullStory",
    description: "Fullstory is on a mission to help technology leaders make better, more informed decisions by injecting behavioral data into their analytics stack. Fullstory unlocks the power of quality behavioral data at scale so enterprises can get closer to their customers\u2019 true sentiment and intentions\u2013predicting what they want, creating personalized experiences, increasing conversion, improving loyalty\u2013and driving revenue.",
    type: "destination",
    link: "/actions-fullstory"
  }]
}, {
  slug: "crm",
  title: "CRM",
  description: "CRM (Customer Relationship Management) is a critical category of technology for businesses in their customer engagement efforts. By leveraging CRM tools, businesses can manage their interactions with customers, track their behavior and preferences, and build stronger relationships. In this section, we'll round up some of the top CRM tools on the Twilio Segment platform and highlight their key features, which allow businesses to create more personalized customer experiences.",
  card: {
    badge: "Recipe",
    title: "Set up lead scoring to improve sales efficiency and accelerate pipeline",
    description: "In this recipe, you'll learn how to set up lead scoring, send those lead scores to your CRM, and keep your sales team focused on the most important accounts.",
    link: "/setting-up-lead-scoring-to-improve-sales-efficiency-and-accelerate-your-pipeline"
  },
  list: [{
    title: "Intercom",
    description: "Intercom is a customer service platform that helps businesses connect with their customers through personalized, targeted messaging. It enables businesses to send messages through multiple channels like email, in-app messages, and push notifications. Real-time and automated messaging allows businesses to engage with customers when they are most active and save time by sending personalized messages to customers at the right time.",
    type: "destination",
    link: "/actions-intercom-cloud"
  }, {
    title: "Freshsales",
    description: "Freshsales is a CRM platform that helps businesses manage their sales pipeline and customer relationships. It has a range of features like lead management, deal management, and email tracking that enable businesses to track customer interactions and sales activities. Freshsales also offers its AI-based lead scoring system to help businesses prioritize their leads based on their likelihood to convert.",
    type: "destination",
    link: "/freshsales-suite-crm"
  }, {
    title: "HubSpot",
    description: "HubSpot is an all-in-one marketing, sales, and service software that helps businesses manage their customer relationships from end-to-end. Its leading offering is its free CRM that allows businesses to manage their customer data and interactions in one place. HubSpot also offers a range of automation features that help businesses save time by automating repetitive tasks, and it integrates with a range of other tools to create a seamless customer experience.",
    type: "destination",
    link: "/actions-hubspot-cloud"
  }, {
    title: "Salesforce",
    description: "As a long time leader in the space, Salesforce is a cloud-based CRM platform that helps businesses manage their customer relationships, sales, and marketing activities. It boasts features like customizable dashboards allow businesses to monitor and track their sales performance in real-time. Salesforce also offers a range of automation features that help businesses save time by automating repetitive tasks, while integrating with a range of other tools to create a seamless customer experience.",
    type: "destination",
    link: "/actions-salesforce"
  }]
}, {
  slug: "customer-success",
  title: "Customer Success",
  description: "Customer success involves managing the customer journey from initial purchase to continued use of a product or service, with the goal of ensuring customer satisfaction and loyalty. By leveraging customer success tools, businesses can proactively monitor customer behavior and preferences, provide targeted guidance, and offer personalized support. To give you the complete overview, we'll take stock of the leading customer success tools being used on the Twilio Segment platform.",
  card: {
    badge: "Recipe",
    title: "Break down data silos between your sales and support teams",
    description: "In this recipe, you\u2019ll learn how to keep sales and support aligned by enriching your user profiles with information from Salesforce and syncing that data to Zendesk.",
    link: "/break-down-data-silos-between-sales-and-support"
  },
  list: [{
    title: "Zendesk",
    description: "Zendesk is a cloud-based customer service platform that offers a suite of tools to help businesses manage customer relationships. The platform offers a multi-channel support system that allows for customer interactions across a variety of channels such as email, chat, phone, and social media. Zendesk also features advanced analytics and reporting tools to help businesses monitor performance and identify areas for improvement.",
    type: "destination",
    link: "/zendesk"
  }, {
    title: "Satismeter",
    description: "Satismeter is a customer feedback management platform that helps businesses measure customer satisfaction and improve customer experience with in-app and email surveys that can be customized to meet specific business needs, automatic trigger-based surveys, and real-time feedback analysis.",
    type: "destination",
    link: "/satismeter"
  }, {
    title: "Totango",
    description: "Totango is a customer success management platform that helps businesses improve customer retention and loyalty. The platform includes real-time customer insights, automated customer engagement campaigns, and customer health scores based on a variety of factors such as usage patterns and engagement history.",
    type: "destination",
    link: "/totango"
  }, {
    title: "Help Scout",
    description: "Help Scout is a customer support platform that enables businesses to manage customer interactions across multiple channels. A shared inbox, knowledge base management system, and automated workflows help streamline customer service processes on the platform. Help Scout also offers advanced reporting and analytics tools to help businesses monitor performance and identify areas for improvement.",
    type: "destination",
    link: "/help-scout"
  }]
}, {
  slug: "email",
  title: "Email",
  description: "In this section, we\u2019ll highlight some of the most powerful email tools available to modern businesses, and how they can help to create meaningful customer experiences. From automated campaigns to A/B testing and dynamic content, these tools provide a range of features to help businesses of all sizes connect with customers more effectively.",
  card: {
    badge: "Recipe",
    title: "Increase conversion with personalized lifecycle campaigns",
    description: "In this recipe, you\u2019ll learn how to create behavior-based email campaigns personalized to different personas of your product.",
    image: (EmailRecipe_default()),
    link: "/increase-conversion-with-personalized-lifecycle-campaigns"
  },
  list: [{
    title: "Customer.io",
    description: "Customer.io is an email marketing automation tool that enables you to send behavior-triggered emails, push notifications, and SMS messages to your customers. Its unique features include a drag-and-drop campaign builder, customer profiles that allow you to store customer data, and real-time analytics that provide insight into your campaigns' performance.",
    type: "destination",
    link: "/customer-io-actions"
  }, {
    title: "MailChimp",
    description: "MailChimp is a popular email marketing tool that allows you to send marketing emails, automated messages, and targeted campaigns to your audience. It offers a variety of email templates, including a drag-and-drop builder, and allows you to segment your audience based on demographics, behavior, and more. MailChimp's key features include A/B testing, which enables you to test different email elements to optimize your campaigns, and e-commerce integration that allows you to track purchases and revenue from your campaigns",
    type: "destination",
    link: "/mailchimp"
  }, {
    title: "Braze",
    description: "Braze is a customer engagement platform that enables you to send personalized messages across channels, including email, push notifications, and in-app messages. It offers a variety of targeting options, including segmentation, behavior-based triggers, and real-time user data. The platform also includes an AI-powered recommendation engine, which allows you to suggest products or content based on user behavior, and advanced reporting that provides insights into engagement and conversion rates.",
    type: "destination",
    link: "/braze-cloud-mode-actions"
  }, {
    title: "Iterable",
    description: "Iterable is a cross-channel marketing automation tool that allows you to send personalized messages across email, SMS, push notifications, in-app messages, and direct mail. It offers a drag-and-drop campaign builder, advanced segmentation, and real-time analytics. Iterable's unique features include workflow automation, which allows you to create complex campaigns with branching logic, and predictive analytics that help you identify the best time to send messages to your audience.",
    type: "destination",
    link: "/iterable"
  }, {
    title: "Airship",
    description: "Founded in 2009 as a pioneer in push notifications, Airship\u2019s platform gives brands the user-level data, engagement channels, AI orchestration and services they need to deliver push notifications, emails, SMS, in-app messages, mobile wallet cards and more to exactly the right person in exactly the right moment \u2014 building trust, boosting engagement, driving action, and growing value.",
    type: "destination",
    link: "/airship"
  }]
}, {
  slug: "personalization",
  title: "Personalization",
  description: "Personalization tools are designed to tailor customer engagement by leveraging data to provide a customized experience. These tools analyze customer interactions, preferences, and behaviors to deliver relevant content, recommendations, and offers in real-time.. This section will delve into some of the leading personalization tools available on the Twilio Segment platform, highlighting their key features and how they contribute to creating a more personalized and engaging customer journey.",
  list: [{
    title: "Movable Ink",
    description: "Movable Ink is a powerful platform that empowers marketers to transform data into unique personalized content for each customer at the moment of engagement. By combining customer data and AI, marketers can leverage Movable Ink to ensure that customers see the most relevant message in email or mobile to improve conversion, loyalty, and engagement.",
    type: "destination",
    link: "/movable-ink"
  }, {
    title: "Talon.one",
    description: "Talon.One is a promotion and loyalty solution that helps brands streamline the process to run and scale their incentive campaigns. The Talon.One platform allows companies to easily build rich promotional campaigns at scale, across both in-store and online channels. Brands can then track the effectiveness of those promotions or loyalty programs and offer personalized offers, target specific products, and increase sales by applying promotions at the shopping-cart level.",
    type: "destination",
    link: "/talonone"
  }, {
    title: "Elastic Path",
    description: "Elastic Path is a leading composable commerce platform that allows marketers and merchants to launch dynamic storefronts and shoppable content that adapts in real-time using conditional rules about when and what to offer shoppers. In just a few clicks, digital teams can personalize shopping experiences for their top customers with loyalty experiences, offer discounts or exclusive savings, target past customers with win-back offers, and target abandoned carts with hyper-relevant promotions.",
    type: "source",
    link: "/elastic-path"
  }, {
    title: "Contentful",
    description: "Contentful is an intelligent composable content platform that enables both technical and non-technical users to easily create, manage, publish, and expand distinct content experiences. The Contentful Platform, Contentful Studio, and the Contentful Ecosystem combine the flexibility of composable content with the intelligence of AI, empowering digital teams to drive business momentum through collaboration, speed, and scale.",
    type: "destination",
    link: "/contentful"
  }]
}, {
  slug: "screen-recording-and-heatmaps",
  title: "Screen Recording and Heatmaps",
  description: "Screen recording & heatmap tools allow businesses to gain an in-depth understanding of their customers' behaviors and preferences by recording user sessions on websites and mobile apps. With this data, companies can identify pain points, areas for improvement, and opportunities to enhance the customer experience. In this section, we'll take a closer look at some of the top screen recording & heatmap tools on the Twilio Segment platform and explore their leading features.",
  list: [{
    title: "Hotjar",
    description: "Hotjar provides a suite of tools designed to analyze and optimize user behavior, allowing businesses to tailor their customer engagement strategies for maximum impact. With Hotjar, businesses can generate heatmaps that reveal which areas of their website or application are most popular or problematic for users. Additionally, Hotjar's feedback tool enables businesses to gather valuable customer insights and use that data to drive engagement. By identifying key areas for improvement, businesses can optimize the user experience, increase engagement, and retain customers.",
    type: "destination",
    link: "/hotjar"
  }, {
    title: "Crazy Egg",
    description: "Crazy Egg is a powerful heatmap tool that empowers businesses to analyze and optimize their customers' experiences. With Crazy Egg, businesses can generate heatmaps of user activity, enabling them to identify popular or problematic areas of their website or application. Additionally, Crazy Egg's visual analytics capabilities allow businesses to track user behavior and optimize the user experience to drive engagement. By understanding how users interact with their website or application, businesses can create a seamless and engaging experience that keeps customers coming back.",
    type: "destination",
    link: "/crazy-egg"
  }, {
    title: "Inspectlet",
    description: "Inspectlet's screen recording and heatmap tools provide businesses with valuable insights into their customers' experiences. With Inspectlet, businesses can watch recordings of user sessions, track user behavior, and analyze the user experience in real-time. This enables businesses to identify areas of their website or application that may be causing frustration or confusion, and make data-driven decisions to enhance customer engagement. Inspectlet also allows businesses to identify patterns in user behavior, allowing them to optimize their customer engagement strategies and improve retention.",
    type: "destination",
    link: "/inspectlet"
  }]
}, {
  slug: "warehouses",
  title: "Warehouses",
  description: "Customer data can come from a wide variety of sources, and it's crucial to have a reliable and scalable way to store and manage that data. This is where data warehouses come in - they allow you to store large amounts of customer data in one place, making it easier to analyze and derive insights from. In this section, we'll cover some of the most popular data warehouses used by Twilio Segment customers today, including BigQuery, Postgres, Redshift, and Snowflake.",
  card: {
    badge: "Recipe",
    title: "Fill the gaps in your profiles using data from your warehouse",
    description: "In this recipe, you\u2019ll set up rETL to automatically pull in both backfill customer data and events from your warehouse to help complete your identity graph and provide a holistic view of your customer\u2019s journey over an extended period of time.",
    link: "/fill-gaps-warehouse-data-retl"
  },
  list: [{
    title: "BigQuery",
    description: "BigQuery is a powerful data warehouse offered by Google Cloud that enables businesses to analyze large datasets quickly and efficiently. With BigQuery, businesses can store, manage, and query their data, making it easy to gain valuable insights into customer behavior and improve their marketing efforts. BigQuery is highly scalable, allowing businesses to easily handle large volumes of data, and is compatible with a wide range of third-party tools and services.",
    type: "destination",
    link: "/bigquery"
  }, {
    title: "Snowflake",
    description: "Snowflake is a cloud-based data warehousing platform that is designed to be highly scalable, efficient, and easy to use. With this cloud warehouse, businesses can store and manage their data with ease, making it easy to access and analyze customer data. Additionally, Snowflake offers a range of advanced features, including automatic backups, data sharing, and multi-cluster warehousing.",
    type: "destination",
    link: "/snowflake"
  }, {
    title: "PostgresSQL",
    description: "PostgreSQL is an open-source relational database management system that is highly customizable and scalable. With PostgreSQL, businesses can store and manage their data with ease, making it easy to access and analyze customer data. PostgreSQL offers a wide range of advanced features, including indexing, replication, and transaction control.",
    type: "destination",
    link: "/postgres"
  }, {
    title: "Databricks",
    description: "Databricks is a unique cloud-based warehouse platform, created by the founders of Apache Spark, Delta Lake, and MLflow. It integrates data warehouses, data lakes, and AI into a single, open platform designed for data and AI workloads. By linking with Twilio Segment, Databricks facilitates the collection, governance, and activation of first-party customer data directly within the data warehouse.",
    type: "destination",
    link: "/databricks"
  }, {
    title: "Redshift",
    description: "Redshift is a cloud-based data warehouse offered by Amazon Web Services that enables businesses to store and analyze large datasets quickly and efficiently. With Redshift, businesses can easily scale their data warehouse to meet their needs, making it an ideal choice for enterprise businesses.",
    type: "destination",
    link: "/redshift"
  }]
}];
/* harmony default export */ var Categories_data = ((/* unused pure expression or super */ null && (data)));
;// CONCATENATED MODULE: ./src/views/CustomerEngagementStack/components/Categories/Categories.tsx


function Categories_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
















var Categories_copy = {
  heading: "Categories"
};

var Categories = function Categories() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Categories_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Categories_StyledSection, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionCopy, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
          variant: "h2",
          tokens: {
            color: theme.palette.twilio.gray[60]
          },
          children: Categories_copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionsList, {
          children: data.map(function (_ref) {
            var slug = _ref.slug,
                title = _ref.title,
                description = _ref.description,
                list = _ref.list,
                card = _ref.card;
            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              id: slug,
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
                  variant: "h2",
                  children: title
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
                  tag: "p",
                  children: description
                }), card ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCardBase, {
                  href: (0,getAbsoluteUrl/* default */.Z)("/recipes".concat(card.link, "/"), pageConfig),
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Body */.uT, {
                    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Accessories */.v8, {
                      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* AccessoriesRow */.OW, {
                        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* default */.Z, {
                          variant: "outlined",
                          children: card.badge
                        })
                      })
                    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card/* Copy */.CK, {
                      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCardHeadline, {
                        children: card.title
                      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCardDescription, {
                        children: card.description
                      }), card.image ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCardImage, {
                        variant: "fill",
                        src: card.image,
                        alt: ""
                      }) : null]
                    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* Action */.aU, {
                      alignment: "left",
                      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
                        iconEnd: Common/* ChevronRightIcon */.XC,
                        children: "Use this recipe"
                      })
                    })]
                  })
                }) : null]
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Categories_Accordions, {
                data: list
              })]
            }, slug);
          })
        })
      })]
    })
  });
};

var Heading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1nudfjd8"
} : 0)( true ? {
  name: "1azpx8r",
  styles: "margin-bottom:20px"
} : 0);

var Categories_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1nudfjd7"
} : 0)( true ? {
  name: "1c6bhpi",
  styles: "max-width:1004px;margin:0 auto"
} : 0);

var Categories_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1nudfjd6"
} : 0)(Section/* Wrapper */.im, "{gap:40px;}" + ( true ? "" : 0));

var StyledSectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e1nudfjd5"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

var AccordionsList = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1nudfjd4"
} : 0)( true ? {
  name: "1gjl9dd",
  styles: "display:flex;flex-direction:column;gap:80px"
} : 0);

var StyledCardBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Card/* default */.ZP,  true ? {
  target: "e1nudfjd3"
} : 0)( true ? {
  name: "1l78b4e",
  styles: "padding-top:40px;padding-bottom:16px"
} : 0);

var StyledCardHeadline = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Card/* Headline */.s0,  true ? {
  target: "e1nudfjd2"
} : 0)( true ? {
  name: "12brwd0",
  styles: "overflow:unset"
} : 0);

var StyledCardDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Card/* Description */.dk,  true ? {
  target: "e1nudfjd1"
} : 0)( true ? {
  name: "12brwd0",
  styles: "overflow:unset"
} : 0);

var StyledCardImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Card/* Image */.Ee,  true ? {
  target: "e1nudfjd0"
} : 0)( true ? {
  name: "xkqanu",
  styles: "width:100%;height:100%;aspect-ratio:auto"
} : 0);

/* harmony default export */ var Categories_Categories = (Categories);
// EXTERNAL MODULE: ./src/views/CustomerEngagementStack/components/Introduction/assets/Introduction@2x.png
var Introduction_2x = __webpack_require__(3817);
var Introduction_2x_default = /*#__PURE__*/__webpack_require__.n(Introduction_2x);
// EXTERNAL MODULE: ./src/views/CustomerEngagementStack/components/Introduction/assets/Introduction.webp
var assets_Introduction = __webpack_require__(38153);
var Introduction_default = /*#__PURE__*/__webpack_require__.n(assets_Introduction);
// EXTERNAL MODULE: ./src/views/CustomerEngagementStack/components/Introduction/assets/Introduction@2x.webp
var assets_Introduction_2x = __webpack_require__(54320);
var assets_Introduction_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Introduction_2x);
;// CONCATENATED MODULE: ./src/views/CustomerEngagementStack/components/Introduction/Introduction.tsx


function Introduction_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var getCopy = function getCopy(_ref) {
  var baseUrl = _ref.baseUrl,
      basePath = _ref.basePath;
  return {
    introduction: ["As we step into 2024, it's evident that customer experiences have become the ultimate differentiator in a fiercely competitive market. At the same time, Artificial Intelligence (AI) and machine learning (ML) have emerged as pivotal forces, revolutionizing the way businesses interact with their customers.", "This paradigm shift has led to the evolution of the traditional tech stack into something more dynamic and customer-centric: what we like to call the Customer Engagement Stack.", "Central to this new stack is the Customer Data Platform (CDP), a tool that unifies data to fuel unparalleled customer experiences. However, the journey towards efficient and fully integrated customer data infrastructure is fraught with challenges. Recent research shows that almost <a href=\"https://www.salesforce.com/news/stories/data-skills-research/\">one-third (30%) of business leaders</a> are overwhelmed by the amount of data across their organizations, which is expected to more than double in size by 2026.", "In our comprehensive <a href=\"".concat(baseUrl).concat(basePath, "/the-cdp-report\">2024 CDP Report</a>, we explored over 12 Trillion API Calls to provide an updated perspective on the technology ecosystems that shape customer interactions. Based on our findings, we've identified the top categories and the most impactful applications that are now critical components of the modern Customer Engagement Stack."), "As you navigate this guide, you\u2019ll learn how the right tools and tactics, with a CDP as your cornerstone, can revolutionize your organization. Embracing this data-driven approach will pave the way for better customer connections, accelerate business growth, and solidify your position as a market leader."]
  };
};

var Introduction = function Introduction() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Introduction_Wrapper, {
    id: "introduction",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
      variant: "h2",
      tag: "h2",
      children: "Introduction"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDivider, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyWrapper, {
      children: getCopy(pageConfig).introduction.map(function (paragraph) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContentParagraph, {
          tag: "span",
          variant: "pLarge",
          dangerouslySetInnerHTML: {
            __html: sanitize_html_default()(paragraph, {
              allowedTags: ["a"]
            })
          }
        }, paragraph);
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Picture, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
        type: "image/webp",
        srcSet: "".concat((Introduction_default()), ", ").concat((assets_Introduction_2x_default()), " 2x")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
        width: "860",
        height: "700",
        src: (Introduction_2x_default()),
        alt: "Illustration: Introduction",
        loading: "lazy"
      })]
    })]
  });
};

var Introduction_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1atthra5"
} : 0)("max-width:844px;padding-top:60px;margin:0 24px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{margin:0 auto;}" + ( true ? "" : 0));

var StyledDivider = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Divider/* default */.Z,  true ? {
  target: "e1atthra4"
} : 0)( true ? {
  name: "qkomnt",
  styles: "margin-bottom:40px"
} : 0);

var CopyWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1atthra3"
} : 0)( true ? {
  name: "1cyzlmv",
  styles: "display:flex;flex-direction:column;align-items:flex-start;gap:24px"
} : 0);

var ContentParagraph = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1atthra2"
} : 0)("margin:0 auto;color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.twilio.gray[100];
}, ";" + ( true ? "" : 0));

var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1atthra1"
} : 0)("color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.twilio.gray[60];
}, ";margin-bottom:20px;" + ( true ? "" : 0));

var Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "e1atthra0"
} : 0)( true ? {
  name: "1gj5on3",
  styles: "margin-top:40px;display:block"
} : 0);

/* harmony default export */ var Introduction_Introduction = (Introduction);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var utils_useScrollToAnchor = __webpack_require__(68714);
;// CONCATENATED MODULE: ./src/views/CustomerEngagementStack/components/GetCustomerEngagementStack/GetCustomerEngagementStack.tsx


function GetCustomerEngagementStack_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var GetCustomerEngagementStack_copy = {
  title: "Get the Customer Engagement Stack in your inbox",
  description: "Learn about the components of a best-in-class Customer Engagement Stack and be inspired by data-driven customer engagement tactics across every industry.",
  button: "Download the ebook"
};

var GetCustomerEngagementStack = function GetCustomerEngagementStack() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var scrollTo = (0,utils_useScrollToAnchor/* default */.Z)("download-the-ebook");
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* default */.ZP, {
    variant: "centered",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GetCustomerEngagementStack_CopyWrapper, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
        variant: "h2",
        tag: "h2",
        children: GetCustomerEngagementStack_copy.title
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
        variant: "pLarge",
        tokens: {
          color: theme.palette.twilio.gray[100]
        },
        children: GetCustomerEngagementStack_copy.description
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
        variant: "filled",
        size: "large",
        color: "primary",
        onClick: function onClick() {
          return scrollTo();
        },
        children: GetCustomerEngagementStack_copy.button
      })]
    })
  });
};

var GetCustomerEngagementStack_CopyWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eyszeh41"
} : 0)("max-width:844px;display:flex;flex-direction:column;align-items:center;text-align:center;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("md");
}, "{padding:0px 80px;}" + ( true ? "" : 0));

var Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "eyszeh40"
} : 0)( true ? {
  name: "1i9vogi",
  styles: "margin-top:0"
} : 0);

/* harmony default export */ var GetCustomerEngagementStack_GetCustomerEngagementStack = (GetCustomerEngagementStack);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Subnav/index.ts + 20 modules
var Subnav = __webpack_require__(49833);
;// CONCATENATED MODULE: ./src/views/CustomerEngagementStack/components/Subnavigation/data.ts

var data_data = [{
  label: "Introduction",
  id: "introduction",
  href: "/customer-engagement-stack/introduction/"
}, {
  label: "Categories",
  items: data.map(function (item) {
    return {
      label: item.title,
      href: "/customer-engagement-stack/".concat(item.slug, "/"),
      id: item.slug
    };
  })
}];
/* harmony default export */ var Subnavigation_data = (data_data);
;// CONCATENATED MODULE: ./src/views/CustomerEngagementStack/components/Subnavigation/Subnavigation.tsx






var Subnavigation_copy = {
  title: "Customer Engagement Stack"
};
var SCROLL_OFFSET = -144;

var Subnavigation = function Subnavigation() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subnav/* default */.Z, {
    "aria-label": Subnavigation_copy.title,
    label: Subnavigation_copy.title,
    children: Subnavigation_data.map(function (item) {
      var _item$items;

      // eslint-disable-next-line  @typescript-eslint/no-non-null-assertion
      var scroll = (0,utils_useScrollToAnchor/* default */.Z)(item.id, SCROLL_OFFSET);
      return "items" in item ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subnav/* Item */.c, {
        label: item.label,
        children: (_item$items = item.items) === null || _item$items === void 0 ? void 0 : _item$items.map(function (subItem) {
          var scroll = (0,utils_useScrollToAnchor/* default */.Z)(subItem.id, SCROLL_OFFSET);
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subnav/* Item */.c, {
            href: (0,getAbsoluteUrl/* default */.Z)(subItem.href, pageConfig),
            label: subItem.label,
            onClick: function onClick(e) {
              e.preventDefault();
              scroll();
            }
          }, subItem.label);
        })
      }, item.label) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subnav/* Item */.c, {
        label: item.label,
        href: (0,getAbsoluteUrl/* default */.Z)(item.href, pageConfig),
        onClick: function onClick(e) {
          e.preventDefault();
          scroll();
        }
      }, item.label);
    })
  });
};

/* harmony default export */ var Subnavigation_Subnavigation = (Subnavigation);
;// CONCATENATED MODULE: ./src/views/CustomerEngagementStack/CustomerEngagementStack.tsx














var CustomerEngagementStack_copy = {
  title: "The Customer Engagement Stack | Twilio Segment",
  description: "Learn about the types of technology and specific applications that top brands use to power their Customer Engagement Stacks."
};

var CustomerEngagementStackView = function CustomerEngagementStackView() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: CustomerEngagementStack_copy.title,
      pageDescription: CustomerEngagementStack_copy.description,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {
        after: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subnavigation_Subnavigation, {})
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Main, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Introduction_Introduction, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopDestinationCategories_TopDestinationCategories, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Categories_Categories, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DividerSection/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GetCustomerEngagementStack_GetCustomerEngagementStack, {})]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
  });
};

var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "ekunjdz0"
} : 0)("background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var CustomerEngagementStack_CustomerEngagementStack = (CustomerEngagementStackView);
;// CONCATENATED MODULE: ./src/pages/customer-engagement-stack.tsx



var CustomerEngagementStack = function CustomerEngagementStack() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomerEngagementStack_CustomerEngagementStack, {});
};

/* harmony default export */ var customer_engagement_stack = (CustomerEngagementStack);

/***/ }),

/***/ 83914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uT": function() { return /* reexport */ Body_Body; },
  "vs": function() { return /* reexport */ ContentWrapper_ContentWrapper; },
  "h4": function() { return /* reexport */ Accordion_Header_Header; },
  "JO": function() { return /* reexport */ Icon_Icon; },
  "yD": function() { return /* reexport */ JsonLdFaq; },
  "DK": function() { return /* reexport */ Accordion_SubTitle_SubTitle; },
  "xv": function() { return /* reexport */ Accordion_Text_Text; },
  "Dx": function() { return /* reexport */ Accordion_Title_Title; },
  "$t": function() { return /* reexport */ TitleWrapper_TitleWrapper; },
  "ZP": function() { return /* reexport */ Accordion_Base_Base; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Icon/Icon.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var VerticalLine = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e73wn6u2"
} : 0)("background:", function (_ref) {
  var background = _ref.background;
  return background;
}, ";opacity:", function (_ref2) {
  var opacity = _ref2.opacity;
  return opacity;
}, ";width:2px;height:12px;transition:300ms background,300ms opacity;position:absolute;top:0;left:5px;" + ( true ? "" : 0));
var HorizontalLine = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e73wn6u1"
} : 0)("background:", function (_ref3) {
  var background = _ref3.background;
  return background;
}, ";width:12px;height:2px;transition:300ms background;position:absolute;top:5px;left:0;" + ( true ? "" : 0));
var IconStyle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e73wn6u0"
} : 0)( true ? {
  name: "xcbroa",
  styles: "width:12px;height:12px;position:relative"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Icon/Icon.tsx


var _excluded = ["tokens"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var BaseIcon = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(IconStyle, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerticalLine, _objectSpread({}, tokens)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalLine, _objectSpread({}, tokens))]
  }));
});
var Icon = (0,useDesignTokens/* withDesignTokens */.Y)(BaseIcon, function (_ref2) {
  var _ref2$opened = _ref2.opened,
      opened = _ref2$opened === void 0 ? false : _ref2$opened;
  return {
    opacity: opened ? 0 : 1
  };
}, {
  dark: function dark(theme, _ref3) {
    var opened = _ref3.opened;
    return {
      background: opened ? theme.palette.brand.segmentGreen[500] : theme.palette.brand.darkAcai[300]
    };
  },
  light: function light(theme, _ref4) {
    var opened = _ref4.opened;
    return {
      background: opened ? theme.palette.brand.boysenberry[500] : theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme, _ref5) {
    var opened = _ref5.opened;
    return {
      background: opened ? theme.palette.twilio.blue[60] : theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Icon_Icon = (Icon);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Icon/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Base/Base.views.ts

var Base = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ejcpq100"
} : 0)("width:100%;border-bottom:1px solid ", function (_ref) {
  var borderColor = _ref.borderColor;
  return borderColor;
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Base/Base.tsx


var Base_excluded = ["children", "tokens"];

function Base_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Base_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Base_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Base_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var AccordionBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Base_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Base, Base_objectSpread(Base_objectSpread(Base_objectSpread({}, tokens), {}, {
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var Base_Base = (0,useDesignTokens/* withDesignTokens */.Y)(AccordionBase, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[300]
    };
  },
  light: function light(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[300]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      borderColor: theme.palette.twilio.gray[20]
    };
  }
});
/* harmony default export */ var Accordion_Base_Base = (Base_Base);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Base/index.ts

// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Text/Text.views.ts


function Text_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Text = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1abg28t0"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Text/Text.tsx


var Text_excluded = ["children", "variant", "tokens"];

function Text_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Text_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Text_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Text_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseText = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "pMedium" : _ref$variant,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Text_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text, Text_objectSpread(Text_objectSpread({
    ref: ref,
    variant: variant,
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var Text_Text = (0,useDesignTokens/* withDesignTokens */.Y)(BaseText, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Accordion_Text_Text = (Text_Text);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Text/index.ts

// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 1 modules
var AnimatePresence = __webpack_require__(51585);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Body/Body.tsx


var Body_excluded = ["children"];

function Body_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Body_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Body_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Body_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var Body = function Body(_ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Body_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnimatePresence/* AnimatePresence */.M, Body_objectSpread(Body_objectSpread({}, rest), {}, {
    initial: false,
    children: children
  }));
};

/* harmony default export */ var Body_Body = (Body);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(48714);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/ContentWrapper/ContentWrapper.views.ts


function ContentWrapper_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xuwow0"
} : 0)( true ? {
  name: "1sk9ltb",
  styles: "padding-bottom:32px;overflow:hidden"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/ContentWrapper/ContentWrapper.tsx


var ContentWrapper_excluded = ["children"];

function ContentWrapper_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function ContentWrapper_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ContentWrapper_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ContentWrapper_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var ContentWrapper = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, ContentWrapper_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion_minimal.m.div, {
    initial: "collapsed",
    animate: "open",
    exit: "collapsed",
    variants: {
      open: {
        opacity: 1,
        height: "auto"
      },
      collapsed: {
        opacity: 0,
        height: 0
      }
    },
    transition: {
      duration: 0.3,
      ease: [0.04, 0.62, 0.23, 0.98]
    },
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, ContentWrapper_objectSpread(ContentWrapper_objectSpread({
      ref: ref
    }, rest), {}, {
      children: children
    }))
  }, "content");
});
/* harmony default export */ var ContentWrapper_ContentWrapper = (ContentWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/ContentWrapper/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Title/Title.views.ts


function Title_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "enok57o0"
} : 0)( true ? {
  name: "139xlyq",
  styles: "text-align:left;margin:16px 0;transition:300ms color"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Title/Title.tsx


var Title_excluded = ["children", "variant", "tokens"];

function Title_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Title_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Title_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Title_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseTitle = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "h4" : _ref$variant,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Title_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, Title_objectSpread(Title_objectSpread({
    ref: ref,
    variant: variant,
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var Title_Title = (0,useDesignTokens/* withDesignTokens */.Y)(BaseTitle, function () {
  return {};
}, {
  light: function light(theme, _ref2) {
    var opened = _ref2.opened;
    return {
      color: opened ? theme.palette.brand.boysenberry[500] : theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme, _ref3) {
    var opened = _ref3.opened;
    return {
      color: opened ? theme.palette.brand.segmentGreen[500] : theme.palette.brand.darkAcai[300]
    };
  },
  twilioLight: function twilioLight(theme, _ref4) {
    var opened = _ref4.opened;
    return {
      color: opened ? theme.palette.twilio.blue[60] : theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Accordion_Title_Title = (Title_Title);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Title/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/SubTitle/SubTitle.views.ts


function SubTitle_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var SubTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "elm17wd0"
} : 0)( true ? {
  name: "jhsf3s",
  styles: "text-align:left;margin:16px 0"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/SubTitle/SubTitle.tsx


var SubTitle_excluded = ["children", "variant", "tokens"];

function SubTitle_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function SubTitle_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? SubTitle_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SubTitle_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseSubTitle = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "pSmall" : _ref$variant,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, SubTitle_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubTitle, SubTitle_objectSpread(SubTitle_objectSpread({
    ref: ref,
    variant: variant,
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var SubTitle_SubTitle = (0,useDesignTokens/* withDesignTokens */.Y)(BaseSubTitle, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Accordion_SubTitle_SubTitle = (SubTitle_SubTitle);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/SubTitle/index.ts

// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/JsonLdFaq/JsonLdFaq.tsx


var JsonLdFaq = function JsonLdFaq(_ref) {
  var data = _ref.data;
  var entities = data.map(function (_ref2) {
    var question = _ref2.question,
        answer = _ref2.answer;
    return {
      '@type': "Question",
      name: question,
      acceptedAnswer: {
        '@type': "Answer",
        text: answer
      }
    };
  });
  var json = {
    '@context': "https://schema.org",
    '@type': "FAQPage",
    mainEntity: entities
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((head_default()), {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(json)
      }
    })
  });
};
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/JsonLdFaq/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/TitleWrapper/TitleWrapper.tsx


var TitleWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e16ehyoi0"
} : 0)( true ? "" : 0);

/* harmony default export */ var TitleWrapper_TitleWrapper = (TitleWrapper);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/TitleWrapper/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Header/Header.views.ts



var Header = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "eqrws8a0"
} : 0)("width:100%;display:grid;gap:28px;grid-template-columns:auto auto;align-items:center;justify-content:space-between;cursor:pointer;margin:12px 0;:hover{", Title, "{color:", function (_ref) {
  var hoverTitleColor = _ref.hoverTitleColor;
  return hoverTitleColor;
}, ";}", HorizontalLine, ",", VerticalLine, "{background-color:", function (_ref2) {
  var hoverIconBackgroundColor = _ref2.hoverIconBackgroundColor;
  return hoverIconBackgroundColor;
}, ";}}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Header/Header.tsx


var Header_excluded = ["children", "onClick", "tokens"];

function Header_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Header_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Header_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Header_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var HeaderBase = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      onClick = _ref.onClick,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Header_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, Header_objectSpread(Header_objectSpread(Header_objectSpread({
    onClick: onClick
  }, tokens), {}, {
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var Header_Header = (0,useDesignTokens/* withDesignTokens */.Y)(HeaderBase, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      hoverTitleColor: theme.palette.brand.segmentGreen[500],
      hoverIconBackgroundColor: theme.palette.brand.segmentGreen[500]
    };
  },
  light: function light(theme) {
    return {
      hoverTitleColor: theme.palette.brand.boysenberry[500],
      hoverIconBackgroundColor: theme.palette.brand.boysenberry[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      hoverTitleColor: theme.palette.twilio.blue[60],
      hoverIconBackgroundColor: theme.palette.twilio.blue[60]
    };
  }
});
/* harmony default export */ var Accordion_Header_Header = (Header_Header);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/Header/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Accordion/index.ts










Accordion_Base_Base.displayName = "AccordionBase";
Accordion_Header_Header.displayName = "Accordion.Header";
Body_Body.displayName = "Accordion.Body";
Accordion_Text_Text.displayName = "Accordion.Text";
Accordion_Title_Title.displayName = "Accordion.Title";
Accordion_SubTitle_SubTitle.displayName = "Accordion.SubTitle";
TitleWrapper_TitleWrapper.displayName = "Accordion.TitleWrapper";
ContentWrapper_ContentWrapper.displayName = "Accordion.ContentWrapper";
Icon_Icon.displayName = "Accordion.Icon";
JsonLdFaq.displayName = "Accordion.JsonLdFaq";


/***/ }),

/***/ 52876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DividerSection_DividerSection; }
});

// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/DividerSection/DividerSection.views.tsx


var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ec103ko0"
} : 0)(Section/* Wrapper */.im, "{padding-top:0;padding-bottom:0;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/DividerSection/DividerSection.tsx





var DividerSection = function DividerSection() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBase, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* default */.Z, {})
    })
  });
};

/* harmony default export */ var DividerSection_DividerSection = (DividerSection);

/***/ }),

/***/ 85507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _DividerSection__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _DividerSection__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52876);


/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 74864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ useActiveState; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(12741);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/utils/useActiveState/useActiveState.tsx



function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var DEFAULT_OPTIONS = {
  allowMultipleActive: false,
  minActive: 0
};
/**
 * A hook that provides a stateful array of booleans and functions to toggle, enable and disable them.
 * @param initialState The initial state of the array of booleans.
 * @param options Options to configure the hook.
 * @returns The stateful array of booleans and functions to toggle, enable and disable them.
 */

var useActiveState = function useActiveState(initialState, options) {
  var _useState = (0,react.useState)(initialState),
      activeItems = _useState[0],
      setActiveItems = _useState[1];

  var settings = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);

  var toggle = function toggle(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    if (items[index]) {
      var activeItemsLength = items.filter(function (item) {
        return item;
      }).length;

      if (activeItemsLength > settings.minActive) {
        items[index] = false;
      }
    } else {
      if (!settings.allowMultipleActive) {
        items = new Array(items.length).fill(false);
      }

      items[index] = true;
    }

    setActiveItems(items);
  };

  var enable = function enable(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    if (!settings.allowMultipleActive) {
      items = new Array(items.length).fill(false);
    }

    items[index] = true;
    setActiveItems(items);
  };

  var disable = function disable(index) {
    var items = (0,toConsumableArray/* default */.Z)(activeItems);

    var activeItemsLength = items.filter(function (item) {
      return item;
    }).length;

    if (activeItemsLength > settings.minActive) {
      items[index] = false;
      setActiveItems(items);
    }
  };

  return {
    activeItems: activeItems,
    setActiveItems: setActiveItems,
    toggle: toggle,
    enable: enable,
    disable: disable
  };
};
;// CONCATENATED MODULE: ../../libs/utils/useActiveState/index.ts


/***/ }),

/***/ 57154:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-engagement-stack",
      function () {
        return __webpack_require__(8065);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 63302:
/***/ (function(module) {

module.exports = "/_next/static/images/AdvertisingRecipe-598fc913bcad5a97f468fdc4938c6c17.png";

/***/ }),

/***/ 96032:
/***/ (function(module) {

module.exports = "/_next/static/images/EmailRecipe-843c61dbd878798f60aad314f5f77c0f.png";

/***/ }),

/***/ 15049:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-34db3863c843959d82f2be98daa4aa7a.png";

/***/ }),

/***/ 3817:
/***/ (function(module) {

module.exports = "/_next/static/images/Introduction@2x-273507fddc22df650edfed508cc35f7a.png";

/***/ }),

/***/ 37640:
/***/ (function(module) {

module.exports = "/_next/static/images/TopDestinationCategories-d097919541fb83b0a63c5897de49df46.png";

/***/ }),

/***/ 2823:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-34db3863c843959d82f2be98daa4aa7a.webp";

/***/ }),

/***/ 38153:
/***/ (function(module) {

module.exports = "/_next/static/images/Introduction-7e51ad079d46e96fb71e1b083fe90b47.webp";

/***/ }),

/***/ 54320:
/***/ (function(module) {

module.exports = "/_next/static/images/Introduction@2x-09a44a0dab4c258ea746487fcaacd975.webp";

/***/ }),

/***/ 76527:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 96969:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 32232:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 24195:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,3607,9137,3254,9129,8834,4330,1382,4136,8392,2073,7096,2429,7303,4488,948,3996,8187,8726,7960,6012,4881,9833,9774,2888,179], function() { return __webpack_exec__(57154); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);